<template>
  <div class="d-inline-block">
    <b-dropdown
      variant="outline"
      right
      boundary="window"
      toggle-class="filter-btn shadow-sm"
      menu-class="filter-menu"
      no-caret
    >
      <template #button-content>
        <font-awesome-icon :icon="['fas', 'th']" size="lg" />
        <span class="filter-badge">{{ value.length }}</span>
      </template>

      <b-dropdown-form class="m-0 p-0">
        <div class="filter-header d-flex justify-content-between align-items-center">
          <div class="d-flex align-items-center">
            <font-awesome-icon :icon="['far', 'sliders-h']" class="header-icon" />
            <span class="font-weight-bold filter-title">Preferencias</span>
          </div>
          <button
            v-if="!isAll"
            type="button"
            class="reset-btn"
            @click="handleAllChange(true)"
          >
            <font-awesome-icon :icon="['far', 'undo-alt']" />
          </button>
        </div>

        <div>
          <b-form-checkbox
            :checked="isAll"
            @change="handleAllChange"
            class="elegant-checkbox"
          >
            <div class="d-flex justify-content-between align-items-center w-100">
              <span class="checkbox-text">Mostrar Todo</span>
              <span class="count-pill" :class="{ 'active-pill': isAll }">{{ total }}</span>
            </div>
          </b-form-checkbox>

          <div class="menu-divider"></div>

          <b-form-checkbox
            v-for="category in categories"
            :key="category.name"
            :checked="value.includes(category.name)"
            @change="toggle(category.name)"
            class="elegant-checkbox"
          >
            <div class="d-flex justify-content-between align-items-center w-100">
              <span class="checkbox-text">{{ category.name }}</span>
              <span class="count-pill" :class="{ 'active-pill': value.includes(category.name) }">
                {{ category.items.length }}
              </span>
            </div>
          </b-form-checkbox>
        </div>
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: 'CategoryFilterBar',
  props: {
    categories: { type: Array, required: true },
    total: { type: Number, required: true },
    value: { type: Array, required: true }
  },
  computed: {
    allNames () {
      return this.categories.map(c => c.name)
    },
    isAll () {
      return this.value.length === this.categories.length
    }
  },
  methods: {
    handleAllChange (checked) {
      if (checked) {
        this.$emit('input', [...this.allNames])
      } else {
        this.$emit('input', [])
      }
    },
    toggle (name) {
      let newValue = [...this.value]
      if (newValue.includes(name)) {
        newValue = newValue.filter(n => n !== name)
      } else {
        newValue.push(name)
      }
      this.$emit('input', newValue)
    }
  }
}
</script>

<style scoped>
::v-deep .filter-btn {
  width: 46px;
  height: 46px;
  background: linear-gradient(135deg, #163D7D 0%, #1c4e9c 100%);
  border: none;
  border-radius: 14px;
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  position: relative;
}

::v-deep .filter-btn:hover, ::v-deep .filter-btn:focus {
  background: linear-gradient(135deg, #1c4e9c 0%, #163D7D 100%);
  color: #ffffff;
  box-shadow: 0 0 14px rgba(22, 61, 125, 0.6) !important;
}

.filter-badge {
  position: absolute;
  top: -4px;
  right: -4px;
  background-color: #f59e0b;
  color: #ffffff;
  font-size: 11px;
  font-weight: bold;
  padding: 2px 7px;
  border-radius: 10px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

::v-deep .filter-menu {
  width: 360px;
  max-width: calc(100vw - 24px);
  min-width: 0;
  border-radius: 20px;
  border: 1px solid rgba(22, 61, 125, 0.08);
  padding: 0;
  box-shadow: 0 0 14px rgba(22, 61, 125, 0.6) !important;
  overflow: hidden;
  background-color: #ffffff;
  margin-top: 10px !important;
}

.filter-header {
  background: linear-gradient(to right, #f8fafc, #ffffff);
  padding: 12px 2px;
  border-bottom: 1px solid #f1f5f9;
}

.header-icon {
  color: #163D7D;
  font-size: 18px;
  margin-right: 12px;
}

.filter-title {
  font-size: 14px;
  color: #1e293b;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.reset-btn {
  background: rgba(22, 61, 125, 0.08);
  border: none;
  color: #163D7D;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 4px 10px;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.reset-btn:hover {
  background: #163D7D;
  color: #ffffff;
}

.menu-divider {
  height: 1px;
  background-color: #f1f5f9;
  margin: 8px 10px;
}

::v-deep .elegant-checkbox {
  margin-bottom: 8px !important;
  border-radius: 12px;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
}


::v-deep .elegant-checkbox .custom-control-label {
  width: 100%;
  cursor: pointer;
  user-select: none;
}

::v-deep .elegant-checkbox .custom-control-label::before,
::v-deep .elegant-checkbox .custom-control-label::after {
  top: 50%;
  transform: translateY(-50%);
  left: -28px;
  width: 18px;
  height: 18px;
}

::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #163D7D;
  border-color: #163D7D;
}

.checkbox-text {
  font-size: 15px;
  color: #64748b;
  font-weight: 500;
  transition: color 0.2s ease;
}

::v-deep .custom-control-input:checked ~ .custom-control-label .checkbox-text {
  color: #163D7D;
  font-weight: 700;
}

.count-pill {
  background-color: #f1f5f9;
  color: #64748b;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 12px;
  border-radius: 20px;
  transition: all 0.2s ease;
}

.active-pill {
  background-color: rgba(22, 61, 125, 0.1);
  color: #163D7D;
}
</style>